import NetworkExceptionEventData from './NetworkEvent.mjs';

class AxiosExceptionEventData extends NetworkExceptionEventData {
  static isAxiosErrorHint(hint) {
    return Boolean(hint?.originalException?.isAxiosError);
  }
  constructor(event, hint) {
    super(event);
    this.hint = hint;
  }
  getRawIdentity() {
    return this.hint.originalException.config.identifier;
  }
  getRawMethod() {
    return this.hint.originalException.config.method;
  }
  getRawStatus() {
    return this.hint.originalException.response?.status;
  }
  getRawEndPoint() {
    return this.hint.originalException.config.url;
  }
  getRawCode() {
    return this.hint.originalException.response?.data?.code;
  }
  getRawMessage() {
    return this.hint.originalException.response?.data?.message;
  }
  getRawExtra() {
    const { response } = this.hint.originalException;
    const data = response?.data;
    const headers = response?.headers;
    return {
      data,
      headers
    };
  }
}

export { AxiosExceptionEventData as default };
//# sourceMappingURL=AxiosEvent.mjs.map
